import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "d-block"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BFormInput = _resolveComponent("BFormInput")
  const _component_BDropdownItem = _resolveComponent("BDropdownItem")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "input-wrapper",
      class: _normalizeClass({searching: $data.searching})
    }, [
      _createVNode(_component_BFormInput, {
        id: "input",
        modelValue: $data.searchValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.searchValue) = $event)),
        placeholder: $props.placeholder,
        debounce: "300",
        onFocus: _cache[1] || (_cache[1] = $event => ($options.restoreDropdown()))
      }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
    ], 2 /* CLASS */),
    _createElementVNode("ul", {
      ref: "dropdownMenu",
      class: _normalizeClass(["dropdown-menu", {show: $data.showDropdown}])
    }, [
      (!$data.items.length)
        ? _renderSlot(_ctx.$slots, "empty", {}, () => [
            _createVNode(_component_BDropdownItem, {
              disabled: "",
              class: "user-select-none"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Keine Ergebnisse ", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            })
          ], true, 0)
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item) => {
        return (_openBlock(), _createBlock(_component_BDropdownItem, {
          key: item[$props.optionIdProp],
          disabled: $props.optionUrlProp && !item[$props.optionUrlProp],
          href: item[$props.optionUrlProp],
          onClick: $event => (!$props.optionUrlProp ? _ctx.$emit('select', item) : null)
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createTextVNode(_toDisplayString(item[$props.optionTextProp]) + " ", 1 /* TEXT */),
              (item[$props.optionSubtextProp])
                ? (_openBlock(), _createElementBlock("small", _hoisted_2, "(" + _toDisplayString(item[$props.optionSubtextProp]) + ")", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (item[$props.optionSubtitleProp])
                ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(item[$props.optionSubtitleProp]), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], true)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "href", "onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2 /* CLASS */)
  ]))
}